import React, { useMemo } from "react";
import CommonTab from "../../../components/TabComponent/CommonTab";
import { useLocation, useNavigate } from "react-router";
import { Link, NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TopTab = () => {
  const { t } = useTranslation();
  const i18n_common = (key) => t(`common.${key}`);
  const TAB = [
    { label: "SLOTS", value: "casino" },
    { label: "LIVE-CASINO", value: "live-casino" },
    { label: "SPORTS", value: "sports" },
    { label: "LOTTERY", value: "lottery" },
    { label: "PROMOTION", value: "promotion" },
  ];

  const location = useLocation();
  const navigate = useNavigate();
  const { pathname } = location;

  return (
    <section className="h-[44px] w-full flex flex-no-wrap overflow-x-scroll overflow-y-hidden no-scrollbar bg-base-light-white dark:bg-base-light-dark">
      {TAB?.map((item) => {
        return (
          <NavLink
            key={item.value}
            to={`/${item.value}`}
            className={({ isActive, isPending }) =>
              isPending
                ? "pending"
                : isActive
                ? "flex min-w-[27%] px-[5px] items-center border-b border-base-white dark:border-base-dark justify-center text-base cursor-pointer relative font-medium text-base-gray dark:text-base-white common-tab-bottom after:bg-main-color"
                : "flex min-w-[27%] px-[5px] items-center border-b border-base-white dark:border-base-dark justify-center text-base cursor-pointer relative font-medium text-[#b7b7b7] dark:text-base-gray"
            }
            // className={`flex items-center border-b justify-center text-base cursor-pointer relative font-medium ${
            //   nowTab === item.value
            //     ? "text-base-gray common-tab-bottom after:bg-main-color"
            //     : "text-[#b7b7b7]"
            // }`}
          >
            <span className="text-overflow">{i18n_common(item.label)}</span>
          </NavLink>
        );
      })}
    </section>
  );
};

export default TopTab;
